import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OESchoolTargetType, OESchoolTargets, OESchoolFeatureAccess, OESchoolStartSelectionData} from './oe-school-model';

export default class OESchoolCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OESchoolTargetType.biology]:   {icon: OEIconCodes.school.biologyTarget, titleId: 'target_menu_biology'},
            [OESchoolTargetType.chemistry]: {icon: OEIconCodes.school.chemistryTarget, titleId: 'target_menu_chemistry'},
            [OESchoolTargetType.geography]: {icon: OEIconCodes.school.geographyTarget, titleId: 'target_menu_geography'},
            [OESchoolTargetType.physics]:   {icon: OEIconCodes.school.physicsTarget, titleId: 'target_menu_physics'},
            [OESchoolTargetType.math]:      {icon: OEIconCodes.school.mathTarget, titleId: 'target_menu_math'},
            [OETarget.effigosExplorerHelp]: {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = OESchoolStartSelectionData.chooseModules().map(module => module.id);
        targetTypes.push(OETarget.effigosExplorerHelp);

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OESchoolTargets}
                featureAccess={OESchoolFeatureAccess}
                startSelectionData={OESchoolStartSelectionData}
            />
        );
    }
}